import { NotificationActionType } from '../action/NotificationAction';

const defaultState = {
  loading: false,
  notifications: [],
  added: false,
  hidden: false,
};

export default function NotificationReducer(state = defaultState, action) {
  switch (action.type) {
    case NotificationActionType.RETRIEVING_NOTIFICATIONS:
    case NotificationActionType.ADDING_NOTIFICATION:
    case NotificationActionType.HIDING_NOTIFICATION:
      return Object.assign({}, defaultState, {
        loading: true,
      });
    case NotificationActionType.NOTIFICATIONS_RETRIEVED:
      return Object.assign({}, defaultState, {
        notifications: action.notifications,
      });
    case NotificationActionType.NOTIFICATION_ADDED:
      return Object.assign({}, defaultState, {
        added: action.id,
      });
    case NotificationActionType.NOTIFICATION_HIDDEN:
      return Object.assign({}, defaultState, {
        hidden: action.id,
      });
    default:
      break;
  }

  return state;
}
